<div>
  <span *ngIf="saveMemberDetailsAddress">{{ 'missing.marketplace.address' | translate }}</span>
  <span *ngIf="saveShippingAddress">{{ 'missing.shipping.address' | translate }}</span>
  <span *ngIf="saveOrderAddress">{{ 'missing.order.address' | translate }}</span>
  <form [formGroup]="addressForm">
    <div class="form-row">
      <div class="form-group col-lg-6">
        <label class="mb-2" for="FirstName">{{ 'address.modal.firstname' | translate }}</label>
        <input
          id="FirstName"
          class="form-control border-0 bg-muted"
          type="text"
          formControlName="FirstName"
          [ngClass]="{ 'is-invalid': hasSubmitted && !!addressForm.controls.FirstName.errors }"
          required
        />
        <div class="invalid-feedback">{{ 'address.modal.firstname.error' | translate }}</div>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-lg-6">
        <label class="mb-2" for="Surname">{{ 'address.modal.lastname' | translate }}</label>
        <input
          id="Surname"
          class="form-control border-0 bg-muted"
          type="text"
          formControlName="Surname"
          [ngClass]="{ 'is-invalid': hasSubmitted && !!addressForm.controls.Surname.errors }"
          required
        />
        <div class="invalid-feedback">{{ 'address.modal.lastname.error' | translate }}</div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-lg-6">
        <label class="mb-2" for="Address1">{{ 'address.modal.street' | translate }}</label>
        <input
          id="Street"
          class="form-control border-0 bg-muted"
          name="Street"
          type="text"
          formControlName="Street"
          [ngClass]="{ 'is-invalid': hasSubmitted && !!addressForm.controls.Street.errors }"
          required
        />
        <div class="invalid-feedback">{{ 'address.modal.street.error' | translate }}</div>
      </div>
      <div class="form-group col-lg-6">
        <label class="mb-2" for="Town">{{ 'address.modal.city' | translate }}</label>
        <input
          id="Town"
          class="form-control border-0 bg-muted"
          name="Town"
          type="text"
          formControlName="Town"
          [ngClass]="{ 'is-invalid': hasSubmitted && !!addressForm.controls.Town.errors }"
          required
        />
        <div class="invalid-feedback">{{ 'address.modal.city.error' | translate }}</div>
      </div>
    </div>

    <fgbcl-country-and-regions [Form]="addressForm" [HasSubmitted]="hasSubmitted"></fgbcl-country-and-regions>

    <div class="form-row">
      <div class="form-group col-lg-6">
        <label class="mb-2" for="Postcode">{{ 'address.modal.postcode' | translate }}</label>
        <input
          id="Postcode"
          class="form-control border-0 bg-muted"
          name="Postcode"
          type="text"
          formControlName="Postcode"
          [ngClass]="{ 'is-invalid': hasSubmitted && !!addressForm.controls.Postcode.errors }"
          required
        />
        <div class="invalid-feedback">{{ 'address.modal.postcode.error' | translate }}</div>
      </div>

      <div class="form-group col-lg-6">
        <label class="mb-2" for="HomeNumber">{{ 'address.modal.number' | translate }}</label>
        <input
          id="HomeNumber"
          class="form-control border-0 bg-muted"
          name="HomeNumber"
          type="tel"
          formControlName="HomeNumber"
          [ngClass]="{ 'is-invalid': hasSubmitted && !!addressForm.controls.HomeNumber.errors }"
          required
        />
        <div class="invalid-feedback">{{ 'address.modal.number.error' | translate }}</div>
      </div>
    </div>
    <div class="form-group">
      <label class="mb-2" for="EmailAddress">{{ 'address.modal.email' | translate }}</label>
      <input
        id="EmailAddress"
        class="form-control border-0 bg-muted"
        type="email"
        formControlName="EmailAddress"
        [ngClass]="{ 'is-invalid': hasSubmitted && !!addressForm.controls.EmailAddress.errors }"
        required
      />
      <div class="invalid-feedback">{{ 'address.modal.email.error' | translate }}</div>
    </div>
  </form>
  <button class="btn btn-danger m-2" (click)="closeModal()">{{ 'address.modal.cancel' | translate }}</button>
  <button class="btn btn-success m-2" (click)="saveAddress()">{{ 'address.modal.save' | translate }}</button>
</div>
